/**
 * Persistent Logger - Logs to localStorage so we can see the full flow
 * even after page redirects and console clears
 */

const isDev = process.env.NODE_ENV === "development";
const LOG_KEY = "DEBUG_LOG";
const MAX_LOGS = 100;

export function addLog(category, message, data = null) {
  if (!isDev) return;
  try {
    const timestamp = new Date().toISOString();
    const logEntry = {
      timestamp,
      category,
      message,
      data,
      url: window.location.href,
    };

    // Get existing logs
    let logs = [];
    try {
      const stored = localStorage.getItem(LOG_KEY);
      logs = stored ? JSON.parse(stored) : [];
    } catch (e) {
      logs = [];
    }

    // Add new log
    logs.push(logEntry);

    // Keep only last MAX_LOGS entries
    if (logs.length > MAX_LOGS) {
      logs = logs.slice(-MAX_LOGS);
    }

    // Store back to localStorage
    localStorage.setItem(LOG_KEY, JSON.stringify(logs));

    // Also log to console
    console.log(`[${category}] ${message}`, data || "");
  } catch (e) {
    console.error("Error in persistent logger:", e);
  }
}

export function getLogs() {
  if (!isDev) return [];
  try {
    const stored = localStorage.getItem(LOG_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch (e) {
    return [];
  }
}

export function clearLogs() {
  if (!isDev) return;
  localStorage.removeItem(LOG_KEY);
  console.log("[Logger] Logs cleared");
}

export function printLogs() {
  if (!isDev) return;
  const logs = getLogs();
  console.clear();
  console.log("=== PERSISTENT DEBUG LOG ===");
  console.log(`Total entries: ${logs.length}`);
  console.log("================================\n");

  logs.forEach((log, index) => {
    console.log(`[${index + 1}] ${log.timestamp}`);
    console.log(`    Category: ${log.category}`);
    console.log(`    Message: ${log.message}`);
    if (log.data) {
      console.log(`    Data:`, log.data);
    }
    console.log(`    URL: ${log.url}`);
    console.log("");
  });
}

// Only expose debug helpers in development
if (isDev && typeof window !== "undefined") {
  window.printDebugLogs = printLogs;
  window.clearDebugLogs = clearLogs;
  console.log("[Logger] Persistent logger initialized. Use window.printDebugLogs() to view all logs");
}
